import { ROUTES } from './routes';

export const TITLES = {
  [ROUTES.ANALYTICS.CONTRACTOR]: 'Передача в заселение',
  [ROUTES.ANALYTICS.TRANSFER_TO_SETTLEMENT]: 'Передача в заселение',
  [ROUTES.ANALYTICS.RATING]: 'Рейтинг заявителей квартир',
  [ROUTES.ANALYTICS.REPORTING_OVP]: 'Отчётность ОВП',
  [ROUTES.ANALYTICS.ROOT]: 'Аналитика',
  [ROUTES.ANALYTICS.APARTMENT_STATUS]: 'Шахматка по квартирам',
  [ROUTES.APARTMENT_LIST.ROOT]: 'Статус квартир',
  [ROUTES.APARTMENT_STATUS.ROOT]: 'Статус квартир',
  [ROUTES.CALLS.APARTMENTS]: 'Квартиры',
  [ROUTES.CALLS.APARTMENTS_ALLOCATED]: 'Распределенные',
  [ROUTES.CALLS.APARTMENTS_UNALLOCATED]: 'Нераспределенные',
  [ROUTES.CALLS.ENG_NETWORKS]: 'Инженерные сети',
  [ROUTES.CALLS.ENG_NETWORKS_ALLOCATED]: 'Распределенные',
  [ROUTES.CALLS.ENG_NETWORKS_UNALLOCATED]: 'Нераспределенные',
  [ROUTES.CALLS.ENG_NETWORKS_MY_CALLS]: 'Мои вызовы на проверке',
  [ROUTES.CALLS.ROOT]: 'Вызовы',
  [ROUTES.DEFECTS.APARTMENTS]: 'Квартиры',
  [ROUTES.DEFECTS.ENG_NETWORKS]: 'Инженерные сети',
  [ROUTES.DEFECTS.ROOT]: 'Дефекты',
  [ROUTES.DELIVERY_SCHEDULE.APARTMENTS_DETAIL]: 'Детальная информация по объекту строительства',
  [ROUTES.DELIVERY_SCHEDULE.APARTMENTS]: 'Квартиры',
  [ROUTES.DELIVERY_SCHEDULE.ROOT]: 'График сдачи в ОВП',
  [ROUTES.DOCUMENTS.ROOT]: 'Документы',
  [ROUTES.ENGINEERING.ROOT]: 'Статус инженерных сетей',
  [ROUTES.PLACEMENTS_STATUS.ROOT]: 'Статус домов',
  [ROUTES.PLAN_ENG_NET_COMMISSIONING.ROOT]: 'План сдачи инженерных сетей',
  [ROUTES.PLAN.ROOT]: 'План',
  [ROUTES.PLAN.PLACEMENTS]: 'Квартиры',
  [ROUTES.PLAN.ENGINEERINGS]: 'Инженерные сети',
  [ROUTES.PLAN.UPLOADING_PLAN_OVP]: 'Загрузка плана',
  [ROUTES.SETTING.ROOT]: 'Настройки',
  [ROUTES.SETTING.APARTMENTS]: 'Квартиры',
  [ROUTES.SETTING.ENG_NET]: 'Инженерные сети',
  [ROUTES.SETTING.ENG_NET_BY_PROJECT]: 'По проекту',
  [ROUTES.SETTING.ENG_NET_BY_OBJECT]: 'По объекту',
  [ROUTES.START_SETTLEMENT.ROOT]: 'Старт заселения',
  [ROUTES.TIMESHEET.ROOT]: 'Календарь загрузки',
  [ROUTES.TIMESHEET.APARTMENTS]: 'Квартиры / Дома',
  [ROUTES.TIMESHEET.ENG_NETWORKS]: 'Инженерные сети',
  [ROUTES.TIMETABLE.ROOT]: 'Расписание сотрудников',
  [ROUTES.TIMETABLE.APARTMENTS]: 'Квартиры',
  [ROUTES.TIMETABLE.APARTMENTS_PROJECTS]: 'По проектам',
  [ROUTES.TIMETABLE.APARTMENTS_MANAGERS]: 'По менеджерам',
  [ROUTES.UPDATES.ROOT]: 'Обновления',
  [ROUTES.UPLOADING_PLAN.APARTMENTS]: 'Квартиры',
  [ROUTES.UPLOADING_PLAN.ROOT]: 'Загрузка планов',
};
